if (!customElements.get('details-disclosure')) {
  class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();
      this.mainDetailsToggle = this.querySelector('details');
      const summary = this.mainDetailsToggle ? this.mainDetailsToggle.querySelector('summary') : null;
      this.content = summary ? summary.nextElementSibling : null;

      if (this.mainDetailsToggle) {
        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
        this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
      }
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    onToggle() {
      if (!this.animations && this.content && typeof this.content.getAnimations === 'function') {
        this.animations = this.content.getAnimations();
      }

      if (this.mainDetailsToggle && this.mainDetailsToggle.hasAttribute('open')) {
        if (this.animations) this.animations.forEach((animation) => animation.play());
      } else {
        if (this.animations) this.animations.forEach((animation) => animation.cancel());
      }
    }

    close() {
      if (this.mainDetailsToggle) {
        this.mainDetailsToggle.removeAttribute('open');
        const summary = this.mainDetailsToggle.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }
    }
  }

  customElements.define('details-disclosure', DetailsDisclosure);
}

if (!customElements.get('header-menu')) {
  const BaseDetails = customElements.get('details-disclosure') || HTMLElement;
  class HeaderMenu extends BaseDetails {
    constructor() {
      super();
      this.header = document.querySelector('.header-wrapper');

      // Attach hover event listeners to the main header menu element
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

      // Handle clicks on desktop to prevent dropdown toggle on mouse clicks
      if (this.mainDetailsToggle) {
        const summary = this.mainDetailsToggle.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', this.onSummaryClick.bind(this));
        }
      }

      // Handle nested submenus (grandchild dropdowns)
      this.querySelectorAll('details').forEach((details) => {
        if (details === this.mainDetailsToggle) return;

        details.addEventListener('mouseenter', () => {
          if (window.matchMedia('(min-width: 990px)').matches) {
            details.setAttribute('open', '');
            const nestedSummary = details.querySelector('summary');
            if (nestedSummary) nestedSummary.setAttribute('aria-expanded', 'true');
          }
        });

        details.addEventListener('mouseleave', () => {
          if (window.matchMedia('(min-width: 990px)').matches) {
            details.removeAttribute('open');
            const nestedSummary = details.querySelector('summary');
            if (nestedSummary) nestedSummary.setAttribute('aria-expanded', 'false');
          }
        });

        const nestedSummary = details.querySelector('summary');
        if (nestedSummary) {
          nestedSummary.addEventListener('click', (event) => {
            const isTouch = window.matchMedia('(pointer: coarse)').matches;
            if (window.matchMedia('(min-width: 990px)').matches && !isTouch && event.detail > 0) {
              // Prevent close on desktop click if it's a mouse click
              event.preventDefault();
              const url = nestedSummary.getAttribute('data-url');
              if (url) {
                window.location.href = url;
              }
            }
          });
        }
      });
    }

    onMouseEnter() {
      if (window.matchMedia('(min-width: 990px)').matches && this.mainDetailsToggle) {
        this.mainDetailsToggle.setAttribute('open', '');
        const summary = this.mainDetailsToggle.querySelector('summary');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }
    }

    onMouseLeave() {
      if (window.matchMedia('(min-width: 990px)').matches) {
        this.close();
      }
    }

    onSummaryClick(event) {
      const isTouch = window.matchMedia('(pointer: coarse)').matches;
      if (window.matchMedia('(min-width: 990px)').matches && !isTouch && event.detail > 0 && this.mainDetailsToggle) {
        // Prevent toggling the details menu when the summary is clicked with a mouse.
        // event.detail > 0 ensures keyboard events (which trigger click with detail = 0) can still toggle it.
        event.preventDefault();
        const summary = this.mainDetailsToggle.querySelector('summary');
        const url = summary ? summary.getAttribute('data-url') : null;
        if (url) {
          window.location.href = url;
        }
      }
    }

    onToggle() {
      if (!this.header || !this.mainDetailsToggle) return;
      this.header.preventHide = this.mainDetailsToggle.open;

      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  customElements.define('header-menu', HeaderMenu);
}
